<!--FastBI产品-->
<template>
  <div class="home-main suite clearfix">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">加密狗</span>
        <span class="title-en">/Encryption Products</span>
        <div class="main-title-right" v-loading="loading">
          <el-button size="medium" class="primary" style="opacity: 0;">申请购买</el-button>
          <el-button size="medium" class="primary" @click="buyFirstDialogOpen">申请购买</el-button>
        </div>
      </div>
      <!--筛选部分start-->
      <div class="product-selector">
        <div class="selector-left">
          <div class="block">
            <span class="demonstration">购买时间</span>
            <el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.openingDateStart" type="date" align="right"
              :picker-options="pickerOptions1" size="small">
            </el-date-picker>
          </div>
          <div class="block">
            <span class="demonstration">到</span>
            <el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.openingDateEnd" type="date" align="right"
              :picker-options="pickerOptions2" size="small">
            </el-date-picker>
          </div>
          <div class="block" v-if="isMaintainer()" >
            <span class="demonstration">伙伴用户名</span>
            <el-input v-model="searchOption.username" style="width: 200px;" size="small" clearable></el-input>
          </div>
        </div>
        <div class="selector-center">
          <div class="group">
            <p>授权码</p>
            <el-input v-model="searchOption.code" size="small" clearable></el-input>
          </div>
        </div>
        <div class="selector-right">
          <el-button size="small" class="warning" @click="search">搜索</el-button>
          <el-button size="small" @click="restSearch">重置</el-button>
        </div>
      </div>
      <!--筛选部分end-->

      <div class="product-main-line"></div>

      <!--产品列表start-->
      <div class="product-main-list">
        <el-table :data="tableData" height="100%" style="width:100%;" stripe>
          <el-table-column width="20">
          </el-table-column>
          <el-table-column label="绑定授权码">
            <template slot-scope="scope">
              <span>{{ scope.row.auth_code }}</span>
            </template>
          </el-table-column>
          <el-table-column label="授权客户">
            <template slot-scope="scope">
              <span>{{ scope.row.auth_name }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="归属伙伴用户名">
            <template slot-scope="scope">
              <span>{{ scope.row.user_loginname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属伙伴名称">
            <template slot-scope="scope">
              <span>{{ scope.row.user_company }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="购买时间">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收件人">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收件地址">
            <template slot-scope="scope">
              <span>{{ scope.row.address }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.note }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--产品列表end-->
      <div class="pagination">
        <el-pagination :disabled="!pagination.use" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[20, 30, 50, 100]" :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
      <!--申请购买弹窗start-->
      <el-dialog :before-close="restbuyFirstForm" title="申请加密狗" :visible.sync="buyFirstDialog" width="506px"
        class="buyFirstDialog">
        <el-form v-if="!payTableShow" :model="buyFirstForm" ref="buyFirstForm" :rules="buyFirstFormRules">
          <el-form-item label="绑定授权码" prop="auth_code" :label-width="formLabelWidth">
            <el-input v-model="buyFirstForm.auth_code" autocomplete="off">
            </el-input>
          </el-form-item>
          <el-form-item label="快递收件人" prop="name" :label-width="formLabelWidth">
            <el-input v-model="buyFirstForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone" :label-width="formLabelWidth">
            <el-input v-model="buyFirstForm.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收件地址" prop="name" :label-width="formLabelWidth">
            <el-input v-model="buyFirstForm.address" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注说明" prop="note" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="buyFirstForm.contact_name" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="支付方式" :label-width="formLabelWidth">
						<el-radio-group v-model="buyFirstForm.pay_type">
							<el-radio :label="0">专用币</el-radio>
							<el-radio :label="1">专用币优先</el-radio>
							<el-radio :label="2">通用币</el-radio>
						</el-radio-group>
					</el-form-item> -->
        </el-form>
        <div v-if="payTableShow" class="clearfix">
          <el-table :data="payTableData" border style="width: 100%">
            <el-table-column prop="auth_code" label="授权码" width="180">
            </el-table-column>
            <el-table-column prop="auth_name" label="授权客户" width="180">
            </el-table-column>
            <el-table-column prop="price" label="价格">
            </el-table-column>
          </el-table>
          <el-alert class="alert" title="支付描述" :type="alertType" :closable="false" :description="payDescription">
          </el-alert>
          <el-button v-if="payBtnShow" class="primary pay_btn" @click="firstBuySure">确认支付</el-button>
        </div>
        <div v-if="!payTableShow" slot="footer" class="dialog-footer">
          <el-button @click="cancel('buyFirstForm', buyFirstDialog = false)">取消购买</el-button>
          <el-button class="primary" @click="buyFirstSubmit">提交</el-button>
        </div>
      </el-dialog>
      <!--申请购买弹窗end-->
    </div>
  </div>
</template>

<script>
import { isvalidPhone } from '@/assets/js/validate';
import { getDongleSaleParam, buyPrice, buy } from "@/api/dongleSale";
import { createGetUrlParams } from "@/utils/url";
import { authStatus, edition } from "@/utils/dataDict";
import { payVerify } from "@/utils/pay";
export default {
  data() {
    //手机号验证
    let validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入电话号码'))
      } else if (!isvalidPhone(value)) {
        callback(new Error('请输入正确的11位手机号码'))
      } else {
        callback()
      }
    }
    //两次密码是否相等
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changKeyForm.newPassword) {
        callback(new Error('两次输入密码请保持一致!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },
      verifyCodeResult: {//接收效验code是否已存在结果
        success: false,
        loading: false,
        icon: ""
      },
      codeLoading: false,
      curentId: 0,//选中表格行的id
      currentIndex: 0,//选中表格行的元素下标
      payTableShow: false,
      payTableData: [],//支付所需价格表
      payData: "",//需要支付的数据
      payBtnShow: false,
      alertType: "success",
      payDescription: "",
      /*筛选条件*/
      searchOption: {
        openingDateStart: '', //选择开通时间-开始
        openingDateEnd: '',//选择开通时间-结束
        expirationDateStart: '',//选择过期时间-开始
        expirationDateEnd: '',//选择过期时间-结束
        customerName: '',//选择授权客户
        code: '',//选择授权码
        username:""
      },

      /*开通时间start*/
      pickerOptions1: {
        shortcuts: [{
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 1);
            picker.$emit('pick', date);
          }
        }, {
          text: '最近7天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', date);
          }
        }, {
          text: '最近90天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', date);
          }
        }, {
          text: '最近1年',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', date);
          }
        }]
      },
      pickerOptions2: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      /*开通时间end*/

      /*过期时间start*/
      pickerOptions3: {
        shortcuts: [{
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 1);
            picker.$emit('pick', date);
          }
        }, {
          text: '最近7天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', date);
          }
        }]
      },
      pickerOptions4: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周后',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '30天后',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', date);
          }
        }]
      },
      /*过期时间end*/

      /*表格数据start*/
      tableData: [],
      /*表格数据end*/

      formLabelWidth: '110px',

      /*申请购买产品start*/
      buyFirstDialog: false,
      buyFirstForm: {
        auth_code: '', //产品授权码
        count: 1, //数量,
        address: '', //地址
        name: '', //收件人
        phone: '', //电话
        note: '',
        pay_type: 2

      },
      buyFirstFormRules: {
        auth_code: [{
          required: true,
          message: '请输入授权码',
          trigger: 'blur'
        },
        {
          pattern: /^[0-9a-zA-Z]{1,}$/,
          message: "只支持输入数字、字母",
          trigger: "blur"
        }],
        name: [{
          required: true,
          message: '请输入收件人姓名',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入收件人地址',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          trigger: 'blur',
          message: '请输入电话'
        }],
        email: [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }
        ],
        count: [{ type: 'number', message: '请输入数字' }]
      },
      buyDate: [{
        value: 12,
        label: '一年'
      }, {
        value: 24,
        label: '两年'
      }, {
        value: 36,
        label: '三年'
      },
      {
        value: 1200,
        label: '买断'
      }],
      /*申请购买产品end*/
    };
  },
  mounted() {
    this.getDongleSaleData()
  },
  methods: {
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getDongleSaleData()
    },
    handleSizeChange(val) {
      if (val <= this.pagination.total) {
        this.pagination.size = val
        this.getDongleSaleData()
      }
    },
    search() {
      this.restPage(true)
      let params = {
        date_start: this.searchOption.openingDateStart,
        date_stop: this.searchOption.openingDateEnd,
        expire_start: this.searchOption.expirationDateStart,
        expire_stop: this.searchOption.expirationDateEnd,
        auth_code: this.searchOption.code,
        username: this.searchOption.username,
      }
      let result = createGetUrlParams(params)

      if (result.success) {
        this.loading = true
        getDongleSaleParam(result.data).then(response => {
          this.tableData = response.results;
          this.pagination.total = response.count;
          this.loading = false
        }).catch(() => {
          this.loading = false
        })

      }
    },
    restSearch() {
      for (const key in this.searchOption) {
        if (this.searchOption.hasOwnProperty(key)) {
          this.searchOption[key] = '';
        }
      }
      this.restPage(true)
      this.getDongleSaleData()
    },
    restPage(isUsePagination) {
      this.pagination.use = isUsePagination
      this.pagination.currentPage = 1
      this.pagination.size = 20
    },
    getDongleSaleData() {
      this.loading = true
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size
      }
      let result = createGetUrlParams(params)
      if (result.success) {
        getDongleSaleParam(result.data).then(response => {
          console.log(response);

          this.loading = false
          this.pagination.total = response.count | 0
          this.tableData = response.results
        }).catch(() => {
          this.loading = false
        })
      }
    },
    getAuthStatus(index) {
      return authStatus[index]
    },
    isMaintainer() {
      // return false
      if (this.$store.getters.userInfo) {
        if (this.$store.getters.userInfo.is_superuser) return true
        return this.$store.getters.userInfo.is_maintainer
      }
      return false
    },
    buyFirstDialogOpen() {//申请购买
      this.payTableShow = false
      this.buyFirstForm.count = 1
      this.buyFirstDialog = true
    },
    buyFirstSubmit() {
      this.$refs.buyFirstForm.validate(valid => {
        if (valid) {
          this.loading = true
          let data = {
            auth_code: this.buyFirstForm.auth_code,
            count: this.buyFirstForm.count
          }
          buyPrice(data).then(response => { //获取此次充值的价格
            response.count = this.buyFirstForm.count
            this.payTableData[0] = response
            this.payTableShow = true

            this.$store.dispatch('user/userinfo') //获取账户余额
              .then(() => {
                this.loading = false
                let finance = {
                  special: this.$store.getters.userInfo.finance.fbi_point,
                  universal: this.$store.getters.userInfo.finance.point
                }
                let parms = {
                  price: response.price,
                  payType: this.buyFirstForm.pay_type
                }
                let result = payVerify(parms, finance) //检测余额是否足够
                this.payDescription = result.msg
                this.payBtnShow = result.success

                if (result.success) {//余额充足
                  this.payData = data
                  this.alertType = "success"
                } else {//余额不足
                  this.alertType = "error"
                }
              })
              .catch(() => {
                this.loading = false
              })
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    firstBuySure() {
      this.loading = true
      buy(this.buyFirstForm).then(response => {
        this.loading = false
        this.$message({
          type: 'success',
          message: '支付成功'
        });
        this.getDongleSaleData()
        this.buyFirstDialog = false
      }).catch(() => {
        this.loading = false
      })
    },
    restbuyFirstForm(done) {
      if (this.$refs.buyFirstForm) this.$refs.buyFirstForm.resetFields()
      done()
    },
    cancel(formName, close) {
      this.$refs[formName].resetFields()
    }
  }
};
</script>

<style lang="scss">
@import url("../../assets/css/product.css");

.suite {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    //background-color: #FFFFFF;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    .main_title {
      margin: 15px 0;
    }

    .product-selector {
      //height: 37px !important;
      background: #fff;

      .selector-center {
        margin-left: 0 !important;
        width: 400px !important;
      }
    }

    .group {
      p {
        margin: 10px 15px 10px 5px !important;
        float: left !important;
        width: 80px !important;
        height: 32px !important;
        line-height: 32px !important;
        text-align: right !important;
      }
    }

    .group .el-input {
      float: left !important;
      margin: 10px 0px !important;
      width: 200px !important;
    }

    .product-main-list {
      flex-grow: 1;
      height: 50%;
    }

    .selector-right {
      height: 100% !important;
      line-height: 50px !important;
    }
  }

  .alert {
    margin-bottom: 10px;
  }

  .pay_btn {
    float: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/Encryption.vue